import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import api from "../../../../../utils/api";
import { T_Evento } from "../../../../../components/selects/celula";
import { useState } from "react";
import { useErrorSuccess } from "../../../../../hooks/useErrorSuccess";

interface ResponseInterface {
  evento?: T_Evento,
  isLoading: boolean,
  alterEvento: (field: keyof T_Evento, value: any) => void,
  submitUpdate: () => Promise<any>
}

const ServicesEdit = (): ResponseInterface => {

  const { id } = useParams();

  const { setMensagemError, setMensagemSuccess } = useErrorSuccess();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [evento, setEvento] = useState<T_Evento>();

  const alterEvento = (field: keyof T_Evento, value: any) => {
    setEvento((val) => ({...val, [field]: value}))
  }

  const invertLoading = () => setIsLoading((value) => !value);

  const get = async () => {
    invertLoading();
    try {
      const req = await api.get<T_Evento>(`evento/geral/${id}`);
      const res = req.data;
      setEvento(res);
      return res;
    } catch(error) {
      setMensagemError(error?.response?.data)
    } finally {
      invertLoading();
    }
  }

  const { data, refetch } = useQuery({
    queryFn: get,
    queryKey: ['evento-batismo-editar', id]
  })

  const submitUpdate = async () => {
    invertLoading();
    try {
      const req = await api.put(`evento/geral/${id}`, evento );
      const res = await req.data;
      setMensagemSuccess('Sucesso!');
    } catch(error) {
      setMensagemError(JSON.stringify(error?.response?.data, null, 2))
    } finally {
      await refetch();
      invertLoading();
    }
  }

  return {
    evento,
    isLoading,
    alterEvento,
    submitUpdate
  };
}

export default ServicesEdit;
